<template>
  <div ref="rootEl" class="home-page">
    <a href="#main-content" class="skip-nav">跳到主要内容</a>

    <main id="main-content" data-component="page-content">
      <HomeHeroSection />
      <HomeCapabilitiesSection />
      <HomeMetricsSection />
      <HomeCasesSection />
      <HomePartnersSection />
      <HomeNewsSection />
      <HomeContactSection />
    </main>
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import HomeCapabilitiesSection from '@/components/home/HomeCapabilitiesSection.vue';
import HomeCasesSection from '@/components/home/HomeCasesSection.vue';
import HomeContactSection from '@/components/home/HomeContactSection.vue';
import HomeHeroSection from '@/components/home/HomeHeroSection.vue';
import HomeMetricsSection from '@/components/home/HomeMetricsSection.vue';
import HomeNewsSection from '@/components/home/HomeNewsSection.vue';
import HomePartnersSection from '@/components/home/HomePartnersSection.vue';
import { useReveal } from '@/composables/useReveal';
import { useSeo } from '@/composables/useSeo';

useSeo({
  title: '海曦技术｜国产化智算中心一体化服务商，云游戏、算力服务、AI加速全栈算力解决方案提供商',
  description:
    '海曦技术专注国产化智算中心建设，提供机房搭建、运维、IaaS/PaaS一体化算力交付，全国布局分布式算力节点，系统可用性达99.99%，7×24小时全天候运维，落地AI、航空仿真、海洋监测等标杆项目，为各行业定制高性能算力支撑方案。'
});

const rootEl = ref<HTMLElement | null>(null);
const route = useRoute();

useReveal(rootEl);

onMounted(async () => {
  await nextTick();
  if (route.hash) {
    requestAnimationFrame(() => {
      document.querySelector(route.hash)?.scrollIntoView({ behavior: 'smooth' });
    });
  }
});
</script>
